const moment = require('moment')
function getInitials(fullname) {
    const fullName = fullname.split(' ');
    const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
    return initials.toUpperCase();
}
function getTime(time = new Date()) {
    return moment(time).format('h:mm A');
}
function getFormattedSessionDate(time = new Date()){
    return moment(time).format('ddd, MMM DD')
}
function getFormattedAssignDate(time = new Date()){
    return moment(time).format('MMM Do, YYYY')
}
function findDuration(time = new Date()){
    return moment(time).format('Do MMM, yyyy')
}
function getTimeLineDate(time = new Date()){
    return moment(time).format('MMM Do, hh:mm A')
}

export default {
    getTimeLineDate,
    getInitials,
    getTime,
    getFormattedSessionDate,
    findDuration,
    getFormattedAssignDate,
}